<template>
  <div>
    <h1 id="title">Andon Atelier</h1>
    <div id="andon_atelier">
      <b-row class="row">
        <b-col class="col-md-2"></b-col>
        <b-col class="col-md-2" id="pin">ACTUEL</b-col>
      </b-row>
      <span v-for="cell in list">
        <span class="row">
          <div class = "col-md-2" id="equips">
            <span>{{cell[0]}}</span>
          </div>
          <div v-for="row in cell[1]" class = "col-md-2" id="equips">
            <h2 v-if="row.state == 'block'" class="cellule_blocked">{{row.state}}</h2>
            <h2 v-else-if="row.state == 'fix'" class="cellule_fixing">{{row.state}}</h2>
            <h2 v-else-if="row.state == 'activ'" class="cellule_activ">{{row.state}}</h2>
            <p v-if="row.duration > 0"><b>Pendant:</b><br>
              {{ Math.trunc((row.duration)/60) }} Minutes</p>
          </div>
        </span>
      </span>
    </div>
  </div>
</template>
<script>

import server from '../../api/server.vue'

export default {
  name: 'AndonAtelier',
  props: ['step', 'title'],
  data() {
    return {
      list: []
    };
  },
  methods: {
    getCellsInfos: function() {
      server.getScansCellByCell().then(data => {
        var tmp = []
        for (var i = 0; i < data.data.length; i++) {
          tmp.push(data.data[i])
        }
        this.list = tmp
      })
      this.setProtectedTimeout(this.getCellsInfos, 60000)
    }
  },
  mounted: function () {
    this.getCellsInfos()
  }
};
</script>

  <style type="text/css">
    #title {
      text-align: center;
      padding-top: 10px;
    }

    #andon_atelier {
      margin-top: 50px;
    }

    #equips {
      box-sizing: border-box;
      box-shadow: 0 0 2px rgba(0,0,0,0.3);
      margin-bottom: 30px;
    }

    #pin {
      box-sizing: border-box;
      box-shadow: 0 0 2px rgba(0,0,0,0.8);
      margin-bottom: 2px;
    }

    .cellule_activ {
       padding-top: 12px;
       background-color: #67ce67;
    }

    .cellule_fixing {
      padding-top: 12px;
      background-color: orange;
    }

    .cellule_blocked {
      padding-top: 12px;
      background-color: red;
    }
  </style>


// WEBPACK FOOTER //
// src/components/andon/andon_atelier.vue